module.exports = __webpack_public_path__ + "img/ill-home-services-mobile-applications.646a9939.svg";